export default function (props: any) {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="40" height="41" viewBox="0 0 40 41" fill="none">
            <path
                d="M30.4266 28.1689C31.022 26.7337 31.3508 25.1621 31.3508 23.5148V9.8376L18.8539 5.8125L6.35785 9.8376V23.5148C6.27776 34.1274 19.39 39.7213 27.1959 32.679"
                stroke="white"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M22.3241 14.9272C20.3056 12.8977 17.2752 12.5094 14.8672 13.759L17.4091 16.3148L14.6558 19.0831L12.1138 16.5273C10.871 18.9477 11.258 21.9954 13.2757 24.0249C15.1732 25.9319 17.964 26.3878 20.2919 25.3979L28.3183 33.4689C29.2568 34.4125 30.7784 34.4116 31.7169 33.4689C32.6554 32.5252 32.6554 30.9954 31.7169 30.0518L23.6905 21.9817C24.6742 19.641 24.2216 16.835 22.3241 14.9272Z"
                stroke="white"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
}
